import React, { useEffect, useMemo } from "react";
import { useModalStore } from "@store/modal/modal";

export const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { modals } = useModalStore();

  const isModalOpen = useMemo(() => !!Object.keys(modals).length, [modals]);

  useEffect(() => {
    const element = document.body;

    if (isModalOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      element.style.overflowY = "hidden";
      if (scrollBarWidth > 0)
        element.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      element.style.overflowY = "auto";
      element.style.paddingRight = "";
    }
  }, [isModalOpen]);

  return <div className="w-full">{children}</div>;
};
